import { Snackbar } from '@mui/material';
import PreviewSigninDrawer from './PreviewSigninDrawer';
import { useSession } from './useEntityPreference';

export default function EntityPreferenceSession() {
    const { session, state } = useSession();
    const signinAction = state.intent?.status === true ? 'follow'
        : state.intent?.status === false ? 'notForMe' : 'preferences';
    return <>
        <PreviewSigninDrawer key={state.intent?.id || 'closed'} open={state.intent?.phase === 'signin'} action={signinAction}
            onClose={session.cancel} onSignedIn={() => session.signedIn(state.intent?.id)} onTransitionExited={() => session.exited(state.intent?.id)} />
        <Snackbar open={Boolean(state.error)} message='Couldn’t save your preference.' onClose={session.dismissError}
            action={<><button type='button' onClick={session.retry}>Retry</button><button type='button' onClick={session.dismissError}>Dismiss</button></>} />
    </>;
}
